module.exports = __webpack_public_path__ + "static/img/partner_6.1a93704.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/partners/partner_6.png
// module id = 8V/M
// module chunks = 0